import React, { memo, useEffect, useRef, useState } from 'react';

import { MINUTES_IN_DAY } from '~/Screens/Calendar/constants';
import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_SMALL } from '~/Constants/UI.constants';
import { PRIMARY_BLUE, TRANSPARENT_WHITE } from '~/Constants/Colors.constants';

export const useStyles = makeStyles(
  {
    timeScale: {
      position: 'absolute',
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      zIndex: 2,
      pointerEvents: 'none',
      height: 0,
    },
    timeScaleLine: {
      height: '1px',
      width: '100%',
      backgroundColor: PRIMARY_BLUE,
    },
    timeScaleTime: {
      fontSize: FONT_SIZE_SMALL,
      color: PRIMARY_BLUE,
      fontWeight: 'bold',
      marginRight: '8px',
      minWidth: '35px',
      background: TRANSPARENT_WHITE,
      zIndex: 1,
    },
    timeScaleBall: {
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      backgroundColor: PRIMARY_BLUE,
    },
  },
  { name: 'TimeLine' },
);

const getCurrentTime = () => {
  const date = new Date();

  return {
    hours: date.getHours(),
    minutes: date.getMinutes(),
  };
};

export const TimeLine = memo(() => {
  const { classes } = useStyles();
  const ref = useRef<null | HTMLDivElement>(null);
  const [{ hours, minutes }, setTime] = useState(() => getCurrentTime());
  const top = `${((hours * 60 + minutes) / MINUTES_IN_DAY) * 100}%`;

  useEffect((): void | (() => void) => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, []);

  useEffect((): void | (() => void) => {
    const timeInterval = setInterval(() => {
      const time = getCurrentTime();
      if (minutes !== time.minutes) {
        setTime(time);
      }
    }, 3000);
    return () => clearInterval(timeInterval);
  }, [minutes]);

  return (
    <div className={classes.timeScale} style={{ top }} ref={ref}>
      <div className={classes.timeScaleTime}>
        {`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`}
      </div>
      <div className={classes.timeScaleBall} />
      <div className={classes.timeScaleLine} />
    </div>
  );
});
